export default __webpack_public_path__ + "static/aiCRMHeroImg-d011cea7152785cca9547a0b6b2f6161.webp";